import { render, staticRenderFns } from "./NotificacoesLink.vue?vue&type=template&id=0b18da6a&"
import script from "./NotificacoesLink.vue?vue&type=script&lang=js&"
export * from "./NotificacoesLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports